import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const idmsResponseContract = c.router({
  postCustomsResponse: {
    method: 'POST',
    path: '/customs-response',
    body: z.record(z.any()),
    responses: {
      200: z.object({}),
    },
  },
  postAesResponse: {
    method: 'POST',
    path: '/aes-response',
    body: z.record(z.any()),
    responses: {
      200: z.object({}),
    },
  },
});
